// 创建文件en/index.js
const en = {
    "my": "मेरा",
    "today": "आज",
    "this_week": "इस सप्ताह",
    "this_month": "इस महीने",
    "last_month": "पिछले महीने",
    "this_year": "इस वर्ष",
    "number_of_people": "लोगों की संख्या",
    "amount": "राशि",
    "enter_username_id_to_search": "खोजने के लिए उपयोगकर्ता नाम आईडी दर्ज करें",
    "team_list": "टीम सूची",
    "Agent.Center": "एजेंट केंद्र",
    "registration_time": "पंजीकरण तिथि",
    "selling_face_value": "विक्रय मूल मूल्य",
    "click_for_details": "विवरण के लिए क्लिक करें",
    "agent_login": "एजेंट लॉगिन",
    "SignOut": "खाता हटाएं",
    "Contact us": "हमसे संपर्क करें",
    "Download our app": "हमारा ऐप डाउनलोड करें",
    "Download it from": "यहां से डाउनलोड करें",
    "About Us": "हमारे बारे में",
    "Gobuy USA was founded in 2012": "गोबाय यूएसए की स्थापना 2012 में की गई थी",
    "Customer service": "ग्राहक सेवा",
    "frequently asked question": "अक्सर पूछे जाने वाले प्रश्न",
    "Return and exchange policy": "वापसी और विनिमय नीति",
    "Shipping and distribution": "शिपिंग और वितरण",
    "Contact us by email": "ईमेल द्वारा हमसे संपर्क करें",
    "Privacy Policy and Terms of Use": "गोपनीयता नीति और उपयोग की शर्तें",
    "Privacy Policy": "गोपनीयता नीति",
    "Terms of use": "उपयोग की शर्तें",
    "Upload credentials": "प्रमाण पत्र अपलोड करें",
    "The withdrawal is being processed": "निकासी की प्रक्रिया हो रही है",
    "Cause of failure": "विफलता का कारण",
    "Your shopping cart is still empty": "आपकी खरीदारी कार्ट अभी भी खाली है",
    "Log in to view the items in your cart": "अपनी कार्ट में आइटम देखने के लिए लॉग इन करें",
    "Browse around": "ब्राउज़ करें",
    "Account correlation": "खाता संबंध",
    "Order management": "ऑर्डर प्रबंधन",
    "Payment method": "भुगतान का तरीका",
    "Collection address": "संग्रहण पता",
    "Gobuy GIFT CARD": "गोबाय गिफ्ट कार्ड",
    "High Priced Recycling": "उच्च मूल्य पुनर्चक्रण",
    "Data": "डेटा",
    "congratulations": "बधाई हो",
    "Obtain": "प्राप्त करें",
    "ThankYouForParticipating": "भाग लेने के लिए धन्यवाद",
    "Home": "मुख्य पृष्ठ",
    "Category": "श्रेणी",
    "Search": "खोजें",
    "ShoppingCart": "खरीदारी कार्ट",
    "Mine": "मेरा",
    "MyCommission": "मेरा कमीशन",
    "Gross income": "कुल आय",
    "Direct commission": "प्रत्यक्ष कमीशन",
    "Indirect commission": "अप्रत्यक्ष कमीशन",
    "Transfer to wallet": "वॉलेट में हस्तांतरित करें",
    "Tip: The transfer amount must be greater than 10USDT": "सुझाव: हस्तांतरण राशि 10USDT से अधिक होनी चाहिए",
    "transfer": "हस्तांतरण",
    "commission": "कमीशन",
    "Please enter": "कृपया दर्ज करें",
    "Team Commission": "टीम कमीशन",

    "EnterSearchContent": "खोज सामग्री दर्ज करें",
    "Recent searches": "हाल की खोजें",
    "popular searches": "लोकप्रिय खोजें",
    "Please search": "कृपया खोजें",
    "orderSearch": "खोजने के लिए ऑर्डर या उत्पाद का नाम दर्ज करें",
    "Language selection": "भाषा चयन",
    "Brand": "ब्रांड",
    "Collect": "संग्रह",
    "Manage": "प्रबंधन करें",
    "Order": "ऑर्डर",
    "Wallet": "वॉलेट",
    "BlindBox": "ब्लाइंड बॉक्स",
    "MenuGiftCard": "उपहार कार्ड",
    "HotSale": "ताज़ा खबरें गर्म बिक्री में हैं...",
    "TodaysOffer": "प्लेटफ़ॉर्म पसंदीदा",
    "Phone": "फ़ोन",
    "Smart Watch": "स्मार्ट वॉच",
    "Smart bracelet": "स्मार्ट ब्रेसलेट",
    "home.gobuy.title": "एक बड़ा आश्चर्य प्राप्त करें",
    "home.gobuy.periods": "ब्लाइंड बॉक्स राउंड",
    "home.gobuy.freeze": "गिनती में शामिल हों",
    "home.gobuy.drawing": "गिनती शुरू करें",
    "home.gobuy.buy": "भाग लें",
    "home.gobuy.isbuy": "भाग लिया",
    "home.gobuy.jackpot": "बोनस पूल",
    "Purse": "पर्स",
    "Box": "बॉक्स",
    "GetAPrize": "एक पुरस्कार प्राप्त करें",
    "Discount": "छूट",
    "when": "जब",
    "points": "अंक",
    "seconds": "सेकंड",
    "MessageBox.Tips": "सुझाव",
    "MessageBox.Confirm": "पुष्टि करें",
    "MessageBox.Cancel": "रद्द करें",
    "MessageBox.buy.box": "क्या आप वाकई इस ब्लाइंड बॉक्स को खरीदना चाहते हैं?",
    "succ": "सफलता",
    "err": "त्रुटि",
    "box.succeeds": "खरीदारी सफल होती है",
    "box.frozen": "पहले ही भाग लिया गया",
    "box.issue": "आप प्रति अंक केवल एक ब्लाइंड बॉक्स खरीद सकते हैं",
    "filter": "फिल्टर",
    "sales": "बिक्री",
    "selfOP": "स्व-परिचालित",
    "noMore": "और नहीं",
    "brand": "ब्रांड",
    "confirm": "पुष्टि करें",
    "reset": "रीसेट",
    "ComSor": "व्यापक क्रमबद्धता",
    "MostPop": "सबसे लोकप्रिय",
    "HighLow": "उच्च से निम्न तक मूल्य",
    "LowHigh": "निम्न से उच्च तक मूल्य",
    "SalVol": "बिक्री मात्रा",
    "NewArr": "नई आगमन",
    "cart.cart": "खरीदारी कार्ट",
    "cart.edit": "संपादित करें",
    "cart.done": "पूरा हुआ",
    "home.cart.voucher": "कूपन प्राप्त करें",
    "home.cart.outstock": "स्टॉक से बाहर",
    "home.cart.offshelf": "शेल्फ से बाहर",
    "Only": "केवल",
    "left": "बाएं",
    "Promotion": "प्रचार",
    "cart.all": "सभी का चयन करें",
    "cart.total": "कुल",
    "cart.delete": "हटाएं",
    "cart.checkout": "चेकआउट",
    "Direct": "प्रत्यक्ष",
    "Indirect": "अप्रत्यक्ष",
    "MyOrders": "मेरे ऑर्डर",
    "ViewAll": "सभी देखें",
    "Unpaid": "अवैतनिक",
    "ToShip": "भेजने के लिए",
    "ToReceive": "प्राप्त करने के लिए",
    "ToReview": "समीक्षा करने के लिए",
    "MyBlindBox": "ब्लाइंड बॉक्स सूची",
    "WaitingDraw": "ड्रा के लिए प्रतीक्षा कर रहा है",
    "Opened": "खुला (उठा / वापस करें)",
    "After sale": "बिक्री के बाद",
    "GiftCard": "उपहार कार्ड सूची",
    "RecycleGiftCard": "उपहार पुनर्चक्रण",
    "Verifying": "पुष्टि के तहत",
    "Rebuying": "पुनः खरीद प्रगति पर",
    "Repurchased": "भुगतान लंबित",
    "Paid": "भुगतान किया गया",
    "CommonTools": "आम उपकरण",
    "MyWallet": "मेरा वॉलेट",
    "VirtualOrders": "वर्चुअल ऑर्डर",
    "Refunds": "वापसी",
    "MyFriends": "मेरे मित्र",
    "ChatList": "चैट सूची",
    "RealNameVerification": "वास्तविक नाम सत्यापन",
    "MyFavorites": "मेरे पसंदीदा",
    "Addresses": "पते",
    "MyReviews": "मेरी समीक्षाएँ",
    "BrowsingHistory": "ब्राउज़िंग",
    "Promotions": "प्रमोशन",
    "StoreManagement": "स्टोर प्रबंधन",
    "BecomeASeller": "विक्रेता बनें",
    "SearchPlaceholder": "खोजने के लिए ऑर्डर आइटम का नाम दर्ज करें",
    "OrderNo": "ऑर्डर नंबर",
    "items": "आइटम",
    "ShippingFee": "शिपिंग शुल्क",
    "Refund in Progress": "वापसी प्रगति में",
    "Cancel Order": "ऑर्डर रद्द करें",
    "Refund": "वापसी",
    "Track Shipping": "शिपिंग ट्रैक करें",
    "Confirm Receipt": "रसीद की पुष्टि करें",
    "Evaluate": "मूल्यांकन करें",
    "Delete": "हटाएं",
    "Pay": "भुगतान करें",
    "MessageBox.delete.order": "क्या आप वाकई इस ऑर्डर को हटाना चाहते हैं?",
    "MessageBox.cancel.order": "क्या आप वाकई इस ऑर्डर को रद्द करना चाहते हैं?",
    "MessageBox.receive.order": "क्या यह ऑर्डर प्राप्त हो गया है?",
    "Order Details": "ऑर्डर विवरण",
    "Pickup Code": "पिकअप कोड",
    "Complaint": "शिकायत",
    "After-Sales": "बिक्री के बाद",
    "Gift": "उपहार",
    "Order Date": "ऑर्डर तिथि",
    "Used voucher worth": "उपयोग किया गया कूपन मूल्य",
    "CNY": "सीएनवाई",
    "Payment Method": "भुगतान का तरीका",
    "Total Product Amount": "कुल उत्पाद राशि",
    "Shipping Fee": "शिपिंग शुल्क",
    "Amount Paid": "भुगतान की गई राशि",
    "Return": "वापसी",
    "Pending Draw": "ड्रा लंबित",
    "Pending Unboxing": "अनबॉक्सिंग लंबित",
    "Unboxed": "अनबॉक्स किया गया",
    "Collected": "संग्रहित",
    "Recycled": "पुनर्चक्रित",
    "Unknown": "अज्ञात",
    "Claim": "दावा करें",
    "Recycle": "पुनर्चक्रण",
    "Unbox": "अनबॉक्स करें",
    "MessageBox.recycle.box": "क्या आप वाकई इस रहस्य बॉक्स को पुनर्चक्रण करना चाहते हैं?",
    "Mystery Box Details": "रहस्य बॉक्स विवरण",
    "Unopened": "अखुला",
    "box.opened": "अखुला",
    "Claimed": "दावा किया गया",
    "Confirm Claim": "दावे की पुष्टि करें",
    "MessageBox.pick.box": "क्या आप वाकई इस ब्लाइंड बॉक्स को उठाना चाहते हैं?",
    "Please add address": "कृपया पता जोड़ें",
    "Face Value Total": "मूल्य कुल",
    "Gift Card Details": "उपहार कार्ड विवरण",
    "Card number": "कार्ड नंबर",
    "Activation code": "सक्रियण कोड",
    "Actual recovery price": "वास्तविक पुनर्प्राप्ति मूल्य",
    "Gift Card Recycling": "उपहार कार्ड पुनर्चक्रण",
    "Confirm Recycling": "पुनर्चक्रण की पुष्टि करें",
    "Please enter the card number": "कृपया कार्ड नंबर दर्ज करें",
    "Please enter the activation code": "कृपया सक्रियण कोड दर्ज करें",
    "MessageBox.recycle.gift": "क्या आप वाकई इस उपहार कार्ड को पुनर्चक्रण करना चाहते हैं?",
    "My Wallet": "मेरा वॉलेट",
    "Available Balance": "उपलब्ध शेष राशि",
    'Gift Balance': "उपहार शेष राशि",
    'All': "सभी",
    'Next event loading': "अगली घटना लोड हो रही है",
    "Frozen Funds": "जमे हुए धन",
    "Recharge": "टॉप-अप",
    "can": "कर सकते हैं",
    "Withdraw": "निकालें",
    "Withdrawal Accounts": "निकासी खाते",
    "Recharge Details": "रिचार्ज विवरण",
    "Recharge Order No.": "रिचार्ज ऑर्डर नंबर",
    "Recharge Amount": "रिचार्ज राशि",
    "Creation Time": "निर्माण समय",
    "MessageBox.recharge.pop": "कृपया रिचार्ज राशि दर्ज करें",
    "payment": "भुगतान",
    "Order submitted successfully, please select payment method": "ऑर्डर सफलतापूर्वक सबमिट किया गया, कृपया भुगतान विधि चुनें",
    "Rechargeable card": "रिचार्ज कार्ड",
    "Please enter a hash": "कृपया एक हैश दर्ज करें",
    "Immediate payment": "तत्काल भुगतान",
    "Wait for the file to load": "फ़ाइल लोड होने की प्रतीक्षा करें",
    "Withdrawal Details": "निकासी विवरण",
    "Withdrawal Amount": "निकासी राशि",
    "Application Time": "आवेदन समय",
    "New Application": "नया आवेदन",
    "Payment Password": "भुगतान पासवर्ड",
    "New Payment Password": "नया भुगतान पासवर्ड",
    "Recipient Information": "प्राप्तकर्ता की जानकारी",
    "Submit": "सबमिट करें",
    "Add Recipient Account First": "पहले प्राप्तकर्ता खाता जोड़ें",
    "Please bind your mobile phone or email first": "कृपया पहले अपना मोबाइल फ़ोन या ईमेल बाँधें",
    "Account Settings": "खाता सेटिंग्स",
    "Change Login Password": "लॉगिन पासवर्ड बदलें",
    "Change Payment Password": "भुगतान पासवर्ड बदलें",
    "Log Out": "लॉग आउट",
    "Mobile": "मोबाइल",
    "Verification Code": "सत्यापन कोड",
    "Email": "ईमेल",
    "Old Password": "पुराना पासवर्ड",
    "New Password": "नया पासवर्ड",
    "Confirm Password": "पासवर्ड की पुष्टि करें",
    "Modify": "संशोधित करें",
    "Bind": "बाँधें",
    " Mobile": " मोबाइल",
    " Email": " ईमेल",
    "Fund Details": "रिकॉर्ड इतिहास",
    "Withdrawal Account": "निकासी खाता",
    "Account Type": "खाता प्रकार",
    "USDT Address (opBNB)": "USDT-opBNB",
    "Edit": "संपादित करें",
    "Add New": "नया जोड़ें",
    "MessageBox.delete.bank": "क्या आप वाकई इस निकासी खाते को हटाना चाहते हैं?",
    "Login": "लॉगिन",
    "Sign Up": "साइन अप",
    "Normal Login": "सामान्य लॉगिन",
    "Username / Email / Phone Number": "उपयोगकर्ता नाम / ईमेल",
    "Enter Phone Number": "फ़ोन नंबर दर्ज करें",
    "Enter Email": "ईमेल दर्ज करें",
    "Enter SMS Code": "एसएमएस कोड दर्ज करें",
    "Enter Password": "पासवर्ड दर्ज करें",
    "enter_login_password_for_verification": "कृपया सत्यापन के लिए अपना लॉगिन पासवर्ड दर्ज करें",
    "Forgot Password": "पासवर्ड भूल गए",
    "Third-party Login": "तीसरे पक्ष का लॉगिन",
    "Please complete the form": "कृपया फ़ॉर्म पूरा करें",
    "WeChat": "वीचैट",
    "Weibo": "वीबो",
    "QQ": "क्यूक्यू",
    "phone login": "फ़ोन लॉगिन",
    "Login Expired": "लॉगिन समाप्त हुआ",
    "Please enter your phone number first": "कृपया पहले अपना फ़ोन नंबर दर्ज करें",
    "Please enter your username/email/phone number": "कृपया अपना उपयोगकर्ता नाम/ईमेल दर्ज करें",
    "Please enter your password": "कृपया अपना पासवर्ड दर्ज करें",
    "Password must be at least 6 characters": "पासवर्ड कम से कम 6 वर्णों का होना चाहिए",
    "Please enter an 11-digit phone number": "कृपया 11-अंकों का फ़ोन नंबर दर्ज करें",
    "Please wait for the file to finish loading": "कृपया फ़ाइल के लोड होने की प्रतीक्षा करें",
    "send": "भेजें",
    "signUpTips": "आपके व्यक्तिगत डेटा का उपयोग आपके अनुभव का समर्थन करने के लिए किया जाएगा, आपकी खाता पहुंच को प्रबंधित करने के लिए, और हमारी गोपनीयता नीति में वर्णित अन्य उद्देश्यों के लिए।",
    "Referrer": "रेफरर",
    "Invitation code": "आमंत्रण कोड",
    'Please.enter.Invitation.code': 'कृपया निमंत्रण कोड दर्ज करें',
    'Email.verification.code': 'ईमेल सत्यापन कोड',
    "Invite friends": "मित्रों को आमंत्रित करें",
    "Username": "उपयोगकर्ता नाम",
    "Full Name": "वास्तविक नाम",
    "Set Password": "पासवर्ड सेट करें",
    "Change password": "पासवर्ड बदलें",
    "Phone Number": "फ़ोन नंबर",
    "Username: 3-25 chars, letters & numbers": "उपयोगकर्ता नाम: 3-25 वर्ण, अक्षर और संख्या",
    "6-20 digits/letters/symbols": "6-20 अंक/अक्षर/प्रतीक",
    "By clicking sign up, you agree to": "साइन अप पर क्लिक करने से आप सहमत होते हैं",
    "User Agreement": "उपयोगकर्ता समझौता",
    "Please check the user agreement": "कृपया उपयोगकर्ता समझौता देखें",
    "Please enter a username with 3-25 characters": "कृपया 3-25 वर्णों का उपयोगकर्ता नाम दर्ज करें",
    "Enter SMS Verification Code": "एसएमएस सत्यापन कोड दर्ज करें",
    "Please enter your phone number": "कृपया अपना फ़ोन नंबर दर्ज करें",
    "verification code": "कृपया सत्यापन कोड दर्ज करें",
    "Please enter a 6-digit verification code": "कृपया 6-अंकों का सत्यापन कोड दर्ज करें",
    "Please enter a password with 6-20 characters": "कृपया 6-20 वर्णों का पासवर्ड दर्ज करें",
    "Please enter the confirm password": "कृपया पासवर्ड की पुष्टि दर्ज करें",
    "The confirm password does not match the entered password": "पुष्टि पासवर्ड दर्ज किए गए पासवर्ड से मेल नहीं खाता",
    "Password Recovery": "पासवर्ड पुनर्प्राप्ति",
    "Forget.email.tips": "यदि आपका खाता अभी तक किसी ईमेल नंबर से लिंक नहीं हुआ है, तो कृपया अपना पासवर्ड पुनर्प्राप्त करने के लिए प्लेटफ़ॉर्म व्यवस्थापक से संपर्क करें।",
    "Notification Message": "सूचना संदेश",
    "Direct Message": "प्रत्यक्ष संदेश",
    "System Message": "प्रणाली संदेश",
    "Leave a Message": "एक संदेश छोड़ें",
    "Delivery Address": "वितरण पता",
    "The store is no longer valid, please edit the delivery address again": "स्टोर अब मान्य नहीं है, कृपया वितरण पता फिर से संपादित करें",
    "Default address": "डिफ़ॉल्ट पता",
    "Add address": "पता जोड़ें",
    "Edit address": "पता संपादित करें",
    "MessageBox.delete.address": "क्या आप वाकई इस पते को हटाना चाहते हैं?",
    "name": "नाम",
    "phone": "फोन",
    "district": "जिला",
    "address": "पता",
    "default address": "डिफ़ॉल्ट पता",
    "save and use": "सहेजें और उपयोग करें",
    "save": "सहेजें",
    "Please select a region": "कृपया एक क्षेत्र चुनें",
    "Please fill in the recipient name": "कृपया प्राप्तकर्ता का नाम भरें",
    "Name must be 2-15 characters": "नाम 2-15 वर्णों का होना चाहिए",
    "Please fill in the mobile phone number": "कृपया मोबाइल फोन नंबर भरें",
    "Please select your location": "कृपया अपना स्थान चुनें",
    "Please fill in the detailed address": "कृपया विस्तृत पता भरें",
    "Browsing History": "ब्राउज़िंग इतिहास",
    "Clear browsing history": "इतिहास साफ़ करें",
    "Promotion member": "प्रचार सदस्य",
    "PromotionPoster": "प्रचार पोस्टर",
    "MemberName": "सदस्य नाम",
    "MyAssets": "मेरी संपत्ति",
    "DistributedAmount": "वितरित राशि",
    "NumberOfDistributedProducts": "वितरित उत्पादों की संख्या",
    "DistributedProductAmount": "वितरित उत्पाद राशि",
    "MyTeam": "मेरी टीम",
    "LevelOneMembers": "स्तर 1 सदस्य",
    "LevelTwoMembers": "स्तर 2 सदस्य",
    "PromotionMembers": "प्रचार सदस्य",
    "PromotionPerformance": "प्रचार प्रदर्शन",
    "ViewPromotionLink": "प्रचार लिंक देखने के लिए क्लिक करें",
    "PromoteViaWeChatQRCode": "वीचैट क्यूआर कोड के माध्यम से प्रचार करें",
    "Copy": "कॉपी करें",
    "BrowserNotSupportedCopyManually": "आपका ब्राउज़र सीधे कॉपी का समर्थन नहीं करता; कृपया मैन्युअल रूप से कॉपी करें",
    "GiftCardRecoveryTotal": "उपहार कार्ड पुनर्प्राप्ति कुल",
    "TodaysGiftCardRecoveryCount": "आज की उपहार कार्ड पुनर्प्राप्ति गणना",
    "RegistrationDate": "पंजीकरण तिथि",
    "LastLogin": "अंतिम लॉगिन",
    "Promotion Commission": "प्रचार कमीशन",
    "Personal Info": "व्यक्तिगत जानकारी",
    "Nickname": "उपनाम",
    "Birthdate": "जन्म तिथि",
    "Save": "सहेजें",
    "CropImage": "छवि काटें",
    "UseImage": "छवि का उपयोग करें",
    "Off": "बंद",
    "Sold": "बिक गया",
    "Product": "उत्पाद",
    "Comment": "टिप्पणी",
    "Details": "विवरण",
    "ReportViolation": "रिपोर्ट",
    "Cart": "कार्ट",
    "ChatMessages": "चैट संदेश",
    "MyShop": "मेरी दुकान",
    "MerchantLogin": "व्यापारी लॉगिन",
    "Share": "साझा करें",
    "ShareTo": "इस पर साझा करें",
    "Poster": "पोस्टर",
    "Follow": "अनुसरण करें",
    "Unfollow": "अनुसरण छोड़ें",
    "PleaseSelectQuantityAndCategory": "कृपया मात्रा और श्रेणी का चयन करें।",
    "SelectedWithQuantity1": "चयनित {specification}, मात्रा {number}.",
    "SelectedQuantity1": "चयनित मात्रा {number}.",
    "SelectedWithQuantity2": "चयनित {specification}, मात्रा {number}.",
    "Add to cart": "कार्ट में जोड़ें",
    "Buy now": "अभी खरीदें",
    "Stock": "स्टॉक",
    "Pieces": " टुकड़े",
    "Quantity": "मात्रा",
    "All": "सभी",
    "Good": "अच्छी समीक्षा",
    "Medium": "मध्यम समीक्षा",
    "Bad": "खराब समीक्षा",
    "Product review": "उत्पाद समीक्षा",
    "anonymous": "अनाम",
    "noReviewInfo": "कोई समीक्षा जानकारी प्रदान नहीं की गई",
    "Shop Owners Response": "दुकान मालिक की प्रतिक्रिया",
    "This product has no current reviews": "इस उत्पाद की कोई वर्तमान समीक्षा नहीं है",
    "Product details": "उत्पाद विवरण",
    "shop": "दुकान",
    "customerService": "ग्राहक सेवा",
    "shoppingCart": "खरीदारी कार्ट",
    "addToCart": "कार्ट में जोड़ें",
    "buyNow": "अभी खरीदें",
    "outOfStock": "चयनित उत्पाद वर्तमान में स्टॉक में नहीं है, हमें खेद है!",
    "notAvailable": "चयनित उत्पाद अब उपलब्ध नहीं है, हमें खेद है!",
    "Store order message": "स्टोर ऑर्डर संदेश",
    "Confirm the order": "ऑर्डर की पुष्टि करें",
    "productAmount": "उत्पाद राशि",
    "discount": "छूट",
    "shippingFee": "शिपिंग शुल्क",
    "subtotal": "स्टोर के लिए उप-योग",
    "Submit an order": "ऑर्डर सबमिट करें",
    "refundAdd": "वापसी जोड़ें",
    "back": "वापस",
    "proofOfRefund": "वापसी का प्रमाण",
    "use": "उपयोग करें",
    "yi1": "एक डॉलर की खरीद",
    "yi2": "मूल्य क्षेत्र",
    "yi3": "क्षेत्र",
    "yi4": "खरीद रिकॉर्ड",
    "yi5": "प्राप्त उत्पादों के रिकॉर्ड",
    "yi6": "रिडेम्पशन कोड देखें",
    "yi7": "निकासी के लिए आवेदन करें",
    "yi8": "रिचार्ज",
    "yi9": "भागीदारी की मात्रा",
    "yi10": "कुल मात्रा",
    "yi11": "घाटे की मात्रा",
    "yi12": "अभी खरीदें",
    "yi13": "खरीदना जारी रखें",
    "yi14": "अन्य क्षेत्र",
    "yi15": "अधिक लोड करें",
    "yi16": "जल्द आ रहा है...",
    "yi17": "क्षेत्र",
    "yi18": "दौर",
    "yi19": "अवधि",
    "yi20": "मूल्य: ",
    "yi21": "अधिक लोड करें",
    "yi22": "त्वरित भुगतान -- उस उत्पाद की जानकारी जिसे आप खरीदना चाहते हैं",
    "yi23": "खरीद की मात्रा",
    "yi24": "(जितना अधिक आप खरीदते हैं, उतनी ही अधिक आपकी उत्पाद प्राप्त करने की संभावना होती है!)",
    "yi25": "कुल: ",
    "yi26": "भुगतान सफल",
    "yi27": "भुगतान विफल",
    "yi28": "कारण: ",
    "yi29": "परिणाम प्रकट हुआ",
    "yi30": "लकी कोड",
    "yi31": "उत्पाद विजेता",
    "yi32": "बधाई हो, आपने इस उत्पाद को जीता",
    "yi33": "प्रकट समय: ",
    "yi34": "खरीद समय: ",
    "yi35": "विजेता द्वारा खरीदी गई कुल संख्या: ",
    "yi36": "खरीद कोड:",
    "yi37": "उठाओ",
    "yi38": "नकद में",
    "yi39": "प्री-ऑर्डर",
    "yi40": "खरीद",
    "yi41": "प्राप्त उत्पादों के रिकॉर्ड",
    "yi42": "जीत की तारीख: ",
    "hunt1": "विनिमय",
    "hunt2": "लकी हेड स्टार्ट",
    "hunt3": "अवरोधन असंभव",
    "hunt4": "विनिमय कोड",
    "hunt5": "विनिमय कोड: ",
    "hunt6": "अधिक लोड करें",
    "hunt7": "मैं उठाना चाहता हूँ",
    "hunt8": "कृपया विनिमय कोड दर्ज करें",
    "hunt9": "विनिमय मूल्य बिक्री मूल्य का 10% है",
    "hunt10": "उत्पाद सूची",
    "hunt11": "क्षेत्र",
    "hunt12": "भाषा",
    "hunt13": "घोषणा",
    "hunt14": "नेविगेशन",
    "hunt15": "आधिकारिक घोषणा",
    "hunt16": "खजाना रिकॉर्ड",
    "hunt17": "शिपिंग नियम",
    "hunt18": "नियम व्याख्या",
    "hunt19": "मैं विनिमय करना चाहता हूँ",
    "hunt20": "हमसे संपर्क करें",
    "hunt21": "ईमेल",
    "hunt22": "लॉटरी नियम",
    "hunt23": "नियम अवलोकन",
    "hunt24": "1. संख्या आवंटन: ",
    "hunt25": "हर 0.1 USDT के लिए, उपयोगकर्ताओं को 000001 से शुरू होने वाली एक लकी संख्या प्राप्त होती है और यह तब तक वितरित की जाती है जब तक कि लक्ष्य प्रतिभागियों की संख्या (उदा. 1000) तक नहीं पहुंच जाती।",
    "hunt26": "2. लॉटरी शर्तें: ",
    "hunt27": "जब उत्पाद लक्ष्य प्रतिभागियों की संख्या (उदा. 1000) तक पहुंच जाता है, तो लॉटरी प्रक्रिया शुरू होती है।",
    "hunt28": "3. लॉटरी समय: ",
    "hunt29": "अंतिम ऑर्डर पुष्टि के बाद, निकटतम ब्लॉकचेन समय की प्रतीक्षा करें जो 05, 10, 15, 25, 30, 35, 40, 45, 50, 55 या पूरे घंटे में समाप्त होता है।",
    "hunt30": "4. विजेता संख्या गणना: ",
    "hunt31": "1. ब्लॉक हैश से शुद्ध संख्या निकालें और कुल प्रतिभागियों के आधार पर मॉड्यूलो की गणना करें: विजेता संख्या = (शुद्ध संख्या % कुल प्रतिभागी) + 1",
    "hunt32": "2. गणना का परिणाम विजेता संख्या के अनुरूप है।",
    "hunt33": "भागीदारी चरण",
    "hunt34": "उपयोगकर्ताओं को हर 0.1 USDT के लिए एक लकी संख्या मिलती है।",
    "hunt35": "जब उत्पाद लक्ष्य प्रतिभागियों की संख्या तक पहुंच जाता है, तो नई प्रविष्टियों को रोक दिया जाता है।",
    "hunt36": "लॉटरी चरण",
    "hunt37": "अंतिम ऑर्डर के समय को सटीकता से रिकॉर्ड करें (उदा. 15:47:23)।",
    "hunt38": "उचित समय समाप्ति के साथ निकटतम ब्लॉकचेन ब्लॉक के उत्पन्न होने की प्रतीक्षा करें:",
    "hunt39": "ब्लॉकचेन समय 05, 10, 15, 25, 30, 35, 40, 45, 50, 55, या घंटे के अंत के साथ समाप्त होता है (उदा. 15:50:00)।",
    "hunt40": "शर्तों के साथ मेल खाने वाले ब्लॉक हैश को प्राप्त करें।",
    "hunt41": "विजेता चरण",
    "hunt42": "ब्लॉक हैश से शुद्ध संख्या निकालें।",
    "hunt43": "उदाहरण ब्लॉक हैश: 0000000000000000000a16b6f44536e521000000adbcf3f4b2ec018ffabcd123",
    "hunt44": "निकाली गई शुद्ध संख्या: 16644536521000000342018123",
    "hunt45": "मॉड्यूलो कुल प्रतिभागी: ",
    "hunt46": "विजेता संख्या",
    "hunt47": "= (निकाली गई संख्या % कुल प्रतिभागी) + 1 ",
    "hunt48": "यदि निकाली गई संख्या 16644536521000000342018123 है, और कुल प्रतिभागी 1000 हैं: ",
    "hunt49": "= (16644536521000000342018123 % 1000) + 1 = 123 + 1 = 124",
    "hunt50": "परिणाम सार्वजनिक करें",
    "hunt51": "प्लेटफ़ॉर्म विजेता संख्या और संबंधित उपयोगकर्ता जानकारी की घोषणा करता है।",
    "hunt52": "पूरी गणना प्रक्रिया भी प्रदान करता है (ऑर्डर समय, उपयोग किया गया ब्लॉक हैश, निकाली गई संख्या, और विजेता संख्या गणना सूत्र)।",
    "hunt53": "लाभ",
    "hunt54": "1. निष्पक्षता",
    "hunt55": "सार्वजनिक ब्लॉकचेन हैश मूल्यों का उपयोग करने से लॉटरी परिणाम अप्रत्याशित और छेड़छाड़-सबूत होते हैं।",
    "hunt56": "2. पारदर्शिता",
    "hunt57": "उपयोगकर्ता हैश मूल्यों और संख्या आवंटन प्रक्रिया की जांच कर सकते हैं।",
    "hunt58": "3. उच्च दक्षता",
    "hunt59": "उचित ब्लॉक की प्रतीक्षा करके परिणामों का त्वरित रूप से निर्धारण किया जा सकता है।",
    "hunt60": "घोषणा विवरण",
    "hunt61": "खरीद राशि: ",
    "hunt62": "आइटम",
    "hunt63": "खरीद कोड के लिए क्लिक करें",
    "hunt64": "खरीद कोड: ",
    "hunt65": "नियम व्याख्या",
    "hunt66": "ऑर्डर्स के बारे में",
    "hunt67": "इस बात को सुनिश्चित करने के लिए कि आप अपने उत्पादों को समय पर प्राप्त करें, 4 बजे से पहले के ऑर्डर उसी दिन XX कुरियर या XX कुरियर द्वारा भेजे जाएंगे। शीघ्र शिपिंग के लिए, कृपया मूल्य अंतर का भुगतान करने के लिए ग्राहक सेवा से संपर्क करें। अन्य कुरियर सेवाएं वर्तमान में समर्थित नहीं हैं।",
    "hunt68": "चालान के बारे में",
    "hunt69": "बेचे गए सभी उत्पादों के लिए इलेक्ट्रॉनिक चालान जारी किया जा सकता है। आप अपने ऑर्डर के माध्यम से ग्राहक सेवा से संपर्क कर सकते हैं और चालान जानकारी प्रदान कर सकते हैं। सामान्यतः, चालान 1-3 दिनों के भीतर जारी किया जाएगा। यदि यह छुट्टियों के दौरान है, तो जारी करने में देरी होगी।",
    "hunt70": "लकीबाय",
    "new1": "उदाहरण",
    "new2": "उत्पाद को 1,000 प्रतिभागियों की आवश्यकता है। अंतिम ऑर्डर समय 15:47:23 है।\nड्रॉ समय के साथ मेल खाता सबसे हाल का ब्लॉक समय 15:50:00 है",
    "new3": "ब्लॉक हैश मूल्य है:",
    "new4": "हैश मूल्य से शुद्ध अंक निकालना:",
    "new5": "विजेता संख्या की गणना:",
    "new6": "विजेता संख्या",
    "new7": "विजेता संख्या 124 है, और संबंधित उपयोगकर्ता विजेता है।",
    "new8": "रिडीम किया गया",
    "new9": "रिडीम नहीं किया गया",
    "new10": "दुर्भाग्यवश, आप नहीं जीते",
    "new11": "बधाई हो",
    "new12": "इस दौर में आइटम जीता",
    "new13": "रिडीम करें",
    "new14": "लकी खरीदारी",
    "new15": "आइटम उठाया गया",
    "new16": "क्या आप वाकई माल को उठाना चाहते हैं?",
    "new17": "क्या आप वाकई रिडीम करना चाहते हैं?",
    "copyS": "कॉपी सफल",
    "copyE": "कॉपी विफल",
    "new18": "उत्पाद प्रदर्शन",
    "new19": "पिछला पृष्ठ",
    "new20": "अगला पृष्ठ",
    "new21": "पर",
    "new22": "पृष्ठ",
    "new23": "पुष्टि करें",
    "new24": "ड्रा की प्रतीक्षा कर रहा है",
    "tool1": "होम",
    "tool2": "उत्पाद",
    "tool3": "समाचार",
    "tool4": "शिकार लॉग",
    "tool5": "शिपिंग",
    "tool6": "नियम",    
    "tool7": "विनिमय",
    "tool8": "संपर्क करें",
    "new25": "उत्पाद विनिमय",
    "new26": "कृपया अपना गोबाय उपयोगकर्ता नाम दर्ज करें",
    "ship1": "लागू दायरा",
    "ship2": "ये शिपिंग नियम लकीबाय ई-कॉमर्स प्लेटफ़ॉर्म पर सभी ऑर्डर्स पर लागू होते हैं। चूंकि प्लेटफ़ॉर्म केवल USDT भुगतान स्वीकार करता है, यह क्रेडिट कार्ड, नकद भुगतान, या माल ढुलाई कटौती का समर्थन नहीं करता। निम्नलिखित नियम इस प्रकार बनाए गए हैं।",
    "ship3": "1. संयुक्त राज्य अमेरिका के भीतर शिपिंग नियम",
    "ship4": "भुगतान के तरीके",
    "ship5": "केवल USDT भुगतान स्वीकार किया जाता है। क्रेडिट कार्ड और नकद निपटान समर्थित नहीं हैं।",
    "ship6": "डिलीवरी सेवा पर नकद",
    "ship7": "डिलीवरी सेवा पर नकद केवल संयुक्त राज्य अमेरिका के भीतर ग्राहकों के लिए उपलब्ध है। शिपिंग लागत का पूर्व भुगतान आवश्यक नहीं है।",
    "ship8": "शिपिंग नीति",
    "ship9": "ऑर्डर राशि में शिपिंग लागत शामिल नहीं है, जिसे अलग से भुगतान करना होता है।",
    "ship10": "डिलीवरी रेंज",
    "ship11": "संयुक्त राज्य अमेरिका के पूरे मुख्य भूमि में डिलीवरी समर्थित है।",
    "ship12": "ग्राहक सूचना",
    "ship13": "ऑर्डर देने के बाद, ग्राहकों को यह सुनिश्चित करना चाहिए कि उनकी संपर्क जानकारी सटीक है। प्राप्ति के समय ग्राहक या उनके द्वारा अधिकृत प्रतिनिधि को माल पर हस्ताक्षर करना आवश्यक है।",
    "ship14": "2. संयुक्त राज्य अमेरिका के बाहर शिपिंग नियम",
    "ship15": "केवल USDT भुगतान स्वीकार किया जाता है। क्रेडिट कार्ड और नकद निपटान समर्थित नहीं हैं।",
    "ship16": "संयुक्त राज्य अमेरिका के बाहर के ग्राहकों को ऑर्डर भुगतान के बाद शिपिंग लागत के लिए अतिरिक्त भुगतान करना आवश्यक है।",
    "ship17": "एक बार अतिरिक्त शिपिंग भुगतान किया जाने पर, प्लेटफ़ॉर्म शिपमेंट की व्यवस्था करेगा।",
    "ship18": "नकद पर डिलीवरी नीति",
    "ship19": "डिलीवरी सेवा पर नकद प्रदान नहीं की जाती है। संयुक्त राज्य अमेरिका के बाहर के ग्राहकों को ऑर्डर संसाधित करने से पहले शिपिंग लागत का भुगतान पूरा करना आवश्यक है।",
    "ship20": "अतिरिक्त शिपिंग लागत की प्रक्रिया",
    "ship21": "ऑर्डर देने के बाद, प्लेटफ़ॉर्म ग्राहक के पते के आधार पर शिपिंग लागत की गणना करेगा और ग्राहक को USDT के माध्यम से अतिरिक्त राशि का भुगतान करने के लिए सूचित करेगा।",
    "ship22": "शिपिंग के लिए भुगतान पूरा होने पर, प्लेटफ़ॉर्म शिपमेंट की व्यवस्था करेगा और लॉजिस्टिक्स ट्रैकिंग जानकारी प्रदान करेगा।",
    "ship23": "डिलीवरी सभी देशों में समर्थित है। विशिष्ट डिलीवरी समय स्थानीय लॉजिस्टिक्स स्थितियों पर निर्भर करता है।",
    "ship24": "ग्राहकों को यह सुनिश्चित करना होगा कि पता और संपर्क जानकारी सटीक हो। गलत जानकारी के कारण किसी भी डिलीवरी विफलता की जिम्मेदारी ग्राहक की होगी।",
    "ship25": "गंतव्य देश में सीमा शुल्क नीतियों के लिए प्लेटफ़ॉर्म जिम्मेदार नहीं है। ग्राहकों को खुद सीमा शुल्क और किसी भी संभावित अतिरिक्त शुल्क को समझना और संभालना चाहिए।",
    "ship26": "टिप्पणियाँ",
    "ship27": "1. एक बार ऑर्डर सफलतापूर्वक भुगतान करने पर, इसे रद्द या रिफंड नहीं किया जा सकता है। ग्राहकों को भुगतान से पहले ऑर्डर जानकारी को सावधानीपूर्वक पुष्टि करने की सलाह दी जाती है।",
    "ship28": "2. लकीबाय परिवहन के दौरान बल के कारण उत्पन्न मुद्दों के लिए जिम्मेदार नहीं है (जैसे प्राकृतिक आपदाएं या नीति परिवर्तन) लेकिन ग्राहकों को उन्हें हल करने में मदद करने का हर संभव प्रयास करेगा।",
    "ship29": "3. किसी भी पूछताछ के लिए, कृपया हमारे प्लेटफ़ॉर्म की ग्राहक सेवा चैनलों से संपर्क करें।",
    "ship30": "आपकी समझ और समर्थन के लिए धन्यवाद!",
    "ship31": "लकीबाय आपकी सेवा में समर्पित है।",
    "Original Price": "मूल मूल्य",
    "Actual Payment": "वास्तविक भुगतान",
    "Balance": "शेष",
    "MessageBox.buy.card": "क्या आप वाकई इस गिफ्ट कार्ड को खरीदना चाहते हैं?",
    "MyCard": "मेरा कार्ड",
    "Please upload pictures": "कृपया चित्र अपलोड करें",
    "Share audit list": "साझा ऑडिट सूची",
    "Share page": "पृष्ठ साझा करें",
    "Audit result": "ऑडिट परिणाम",
    "Share to the community": "समुदाय में साझा करें",
    "imshares1": "चरण परिचय",
    "imshares2": "चरण 1: उत्पाद को सोशल मीडिया पर साझा करें।",
    "imshares3": "चरण 2: उत्पाद के साझा किए गए पृष्ठ का स्क्रीनशॉट लें और उसे GoBuy पर अपलोड करें।",
    "Share Time": "साझा समय",
    "Audit status": "ऑडिट स्थिति",
    "Reason for failure": "विफलता का कारण",
    "Pending approval": "मंजूरी लंबित",
    "Approved": "स्वीकृत",
    "Audit failed": "ऑडिट विफल",
    "Url Copied": "लिंक सफलतापूर्वक कॉपी किया गया, साझा करने के लिए पुनःनिर्देशित किया जा रहा है...",
    "Points Logs": "अंक लॉग",
    "My Points": "मेरे अंक",
    "Go Excharge": "विनिमय के लिए जाएं",
    "Confirm points excharge": "क्या आप वाकई सभी अंकों को शेष में बदलना चाहते हैं?",
    "is not share": "आपने अभी तक साझा करने का कार्य पूरा नहीं किया है",
    "is buied": "आपने आज पहले ही खरीदारी कर ली है",
    "My card": "मेरा कार्ड",
    "Country/Region": "देश/क्षेत्र",
    "Contact info": "संपर्क जानकारी",
    "Please enter realname": "कृपया वास्तविक नाम दर्ज करें",
    "Please enter Phone Number": "कृपया फोन नंबर दर्ज करें",
    "Please enter State/Province/Region": "कृपया राज्य/प्रांत/क्षेत्र दर्ज करें",
    "Please enter City": "कृपया शहर दर्ज करें",
    "Please enter Street Address": "कृपया सड़क का पता दर्ज करें",
    "Please enter Postal Code": "कृपया डाक कोड दर्ज करें",
    "lucky_draw_winning_products": "लकी बाय ड्रा में जीते गए उत्पाद",
    "refundDescription": "वापसी विवरण",
    "productQualityIssue": "उत्पाद गुणवत्ता समस्या",
    "logisticsTransportIssue": "लॉजिस्टिक्स और परिवहन समस्या",
    "sellerPlatformIssue": "विक्रेता या प्लेटफ़ॉर्म समस्या",
    "personalReason": "व्यक्तिगत कारण",
    "otherSpecialCases": "अन्य विशेष मामलों",
    "hunt points rule": "अंक नियम",
    "hunt points rule1": "1. अंक अर्जित करना: उपयोगकर्ता भाग्यशाली खरीदारी में भाग ले सकते हैं और प्रत्येक $0.1 निवेश पर 1 अंक अर्जित कर सकते हैं",
    "hunt points rule2": "2. अंक विनिमय: 1 अंक = 0.01% डॉलर",
    'Login Password': "लॉगिन पासवर्ड",
    "Level": "स्तर",
    
    "guide.Rewards": "इनाम परिचय",
    "guide.title": "शुरुआती मार्गदर्शिका",
    "guide.Invitation.Reward": "ईवेंट इनाम",
    "guide.Order.Sharing": "आर्डर साझा करना",
    "guide.section1.title": "लकी बाय खरीदने की गाइड",
    "guide.section1.step1": "खरीदारी चुनें: यूएसडी सेक्शन में जाएं और अपनी पसंदीदा वस्तु चुनें।",
    "guide.section1.step2": "संख्या चुनें: अपनी भागीदारी के लिए इच्छित मात्रा दर्ज करें।",
    "guide.section1.step3": "खरीद मात्रा: केवल $0.1 में 1 यूनिट खरीदें।",
    "guide.section1.step4": "ड्रा की प्रतीक्षा करें: सिस्टम स्वतः विजेता का चयन करेगा।",
    "guide.section2.title": "ब्लाइंड बॉक्स खरीदने की गाइड",
    "guide.section2.step1": "ब्लाइंड बॉक्स खोलें: ब्लाइंड बॉक्स सेक्शन में क्लिक करें।",
    "guide.section2.step2": "तुरंत भाग लें: 10 अमेरिकी डॉलर का भुगतान करें।",
    "guide.section2.step3": "पुरस्कार खोलें: 3 मिलियन अमेरिकी डॉलर तक के पुरस्कार जीतें।",
    "guide.section3.title": "गिफ्ट कार्ड खरीदने की गाइड",
    "guide.section3.step1": "समुदाय में साझा करें: अभी अभियान साझा करें और जानकारी अपलोड करें।",
    "guide.section3.step2": "मूल्य चुनें: गिफ्ट कार्ड की कीमत स्वतंत्र रूप से चुनें।",
    "guide.section3.step3": "100 गिफ्ट कार्ड सिर्फ $98 में खरीदें।",
    "guide.section3.step4": "तुरंत पुनःखरीद: 100% पुनःखरीद पर $2 कमाएं",
    "guide.tip.title": "सावधानीपूर्वक सुझाव: शानदार लाभ को मिस न करें",
    "guide.tip.luckyBuy": "केवल 0.1 डॉलर में भाग लें, 1 से 50,000 डॉलर तक के पुरस्कार जीतने का मौका!",
    "guide.tip.luckyBuy1": "टीम कमीशन पुरस्कार: दोस्तों को खरीदारी के लिए आमंत्रित करें, अधिकतम 0.2% कमीशन पाएं!",
    "guide.tip.luckyBuy2": "पॉइंट रिडेम्पशन: प्रत्येक लकी बाय खरीदने पर 1 पॉइंट कमाएं, 1000 पॉइंट = 0.1 डॉलर!",
    "guide.tip.example": "उदाहरण:",
    "guide.tip.example1": "आपने यूजर A को आमंत्रित किया, A ने 1000 डॉलर खरीदे → आपको 2 डॉलर कमीशन मिला।",
    "guide.tip.example11": "A ने यूजर B को आमंत्रित किया, B ने 1000 डॉलर खरीदे → आपको 1 डॉलर और कमीशन मिला।",
    "guide.tip.boxTitle": "ब्लाइंड बॉक्स लॉटरी",
    "guide.tip.box": "10 डॉलर में एक बार भाग लें, पुरस्कार मूल्य 3 मिलियन डॉलर तक!",
    "guide.tip.cardTitle": "गिफ्ट कार्ड",
    "guide.tip.card": "टीम कमीशन: दोस्तों को खरीदारी के लिए आमंत्रित करें, अधिकतम 0.4% कमीशन पाएं!",
    "guide.tip.example2": "जब आप उपयोगकर्ता A को $100 का गिफ्ट कार्ड खरीदने के लिए आमंत्रित करते हैं, तो आपको $0.4 का कमीशन मिलेगा।",
    "guide.tip.example3": "यदि A उपयोगकर्ता B को आमंत्रित करता है और B $100 का गिफ्ट कार्ड खरीदता है, तो आपको $0.2 का अतिरिक्त कमीशन मिलेगा।",
    "guide.tip.callToAction": "अभी भाग लें और अपनी भाग्यशाली यात्रा शुरू करें!",
    "guide.warning.title": "सावधानीपूर्वक सूचना",
    "guide.warning.rule1": "कौन सी स्थितियां कमीशन को अमान्य करती हैं?",
    "guide.warning.answer1": "सॉफ़्टवेयर या अन्य प्लेटफ़ॉर्म का उपयोग करके गलत तरीके से कमीशन प्राप्त करना, पुष्टि होने पर सभी कमीशन काट लिए जाएंगे और खाता बंद कर दिया जाएगा।",
    "guide.warning.rule2": "क्या मैं खुद को आमंत्रित करके कमीशन प्राप्त कर सकता हूँ?",
    "guide.warning.answer2": "नहीं। हम मैनुअल जांच करते हैं, धोखाधड़ी पाए जाने पर सभी कमीशन काट लिए जाएंगे, निमंत्रण कमीशन रद्द कर दिया जाएगा और आपका खाता हटा दिया जाएगा।",
    "invite.title": "लाभ आ गए हैं | दोस्तों को आमंत्रित करें और 4 बड़े पुरस्कार जीतें!",
    "invite.reward1.title": "पुरस्कार 1: समूह में जोड़ें, आसानी से डॉलर + गिफ्ट कार्ड कमाएं",
    "invite.reward1.item1": "प्रत्येक 10 सफल नए सदस्यों को समूह में जोड़ने पर रेड एनवलप पुरस्कार पाएं!",
    "invite.reward1.item2": "साथ ही 1 डॉलर का गिफ्ट कार्ड भी पाएं",
    "invite.reward1.item3": "जितना ज्यादा आमंत्रित करें, उतना ज्यादा कमाएं! रेड एनवलप तुरंत भेजे जाते हैं, गिफ्ट कार्ड तुरंत रिडीम करें!",
    "invite.reward2.title": "पुरस्कार 2: लकी बाय, आराम से कमीशन कमाएं",
    "invite.reward2.item1": "दोस्तों के लकी बाय में भाग लेने पर आपको कमीशन मिलता है!",
    "invite.reward2.item2": "कोई सीमा नहीं, जितना ज्यादा वे खरीदेंगे, उतना ज्यादा आप कमाएंगे!",
    "invite.reward3.title": "पुरस्कार 3: गिफ्ट कार्ड",
    "invite.reward3.item1": "दोस्तों द्वारा गिफ्ट कार्ड खरीदने पर तुरंत कमीशन पाएं!",
    "invite.reward3.item2": "शून्य लागत साझा लिंक, स्वचालित ट्रैकिंग, सुपर आसान:",
    "invite.reward3.item3": "लिंक भेजें → दोस्त ऑर्डर करें → भुगतान प्राप्त करें!",
    "invite.callToAction": "जल्दी करें, अपने दोस्तों को समूह में शामिल करें और सारे लाभ अपने साथ घर ले जाएं! चलो खेलते हुए कमाएं!",
    "share.title": "GoBuy जीत साझा करें और 1 डॉलर गिफ्ट कार्ड जीतें",
    "share.subtitle": "शीर्षक साझा करें",
    "share.content1": "GoBuy लकी शॉपिंग के लिए धन्यवाद। हमारे एक सदस्य ने आज एक छोटा निवेश किया, पुरस्कार जीता और सफलतापूर्वक निकासी की! ✨",
    "share.content2": "अब आपकी बारी है! अपनी जीत का अनुभव साझा करें और मुफ्त 1 डॉलर GoBuy गिफ्ट कार्ड पाएं! इसे मत चूकिए — सरल, पुरस्कारपूर्ण, और मज़ेदार!",
    "share.inviteLink": "अपना निमंत्रण कोड संलग्न करें:",
    "share.stepsTitle": "भाग लेने का तरीका:",
    "share.step1": "लकी बाय क्षेत्र में अपने खरीद/ऑर्डर कोड का स्क्रीनशॉट अपलोड करें",
    "share.step2": "“बधाई हो, आपने जीता!” संदेश का स्क्रीनशॉट अपलोड करें",
    "share.step3": "अपने निकासी अनुरोध और सफल लेन-देन का स्क्रीनशॉट अपलोड करें",
    "share.step4": "ऊपर दिए गए चरणों को पूरा करने के बाद, सत्यापन के लिए अपने सोशल मीडिया शेयर का स्क्रीनशॉट ग्राहक सेवा टीम को भेजें",
    "share.email": "ग्राहक सहायता ईमेल:",
    "share.footer": "भाग्य आपके साथ हो — खेलते रहें, जीतते रहें! GoBuy — खरीदारी को हर दिन मज़ेदार और लाभकारी बनाएं!",
    "doubleBet.title": "बेटिंग चमत्कार｜3 सरल कदम, पलटें और बड़े पुरस्कार जीतें!",
    "doubleBet.step1": "राउंड 1: $1 जोन चुनें, $0.5 खरीदें, 5 यूनिट खरीदें, और जीतने पर रुक जाएं।",
    "doubleBet.step2": "यदि न जीतें, राउंड 2: $3 जोन चुनें, $1.5 खरीदें, 15 यूनिट खरीदें, और जीतने पर रुक जाएं।",
    "doubleBet.step3": "यदि अब भी न जीतें, राउंड 3: $8 जोन चुनें, $4 खरीदें, 40 यूनिट खरीदें, बधाई हो जीतने पर।",
    "doubleBet.step4": "जीतने के बाद, आप पिछले राउंड के नुकसान को कवर कर सकते हैं और लाभ कमा सकते हैं, फिर राउंड 1 से शुरू करें।",
    "invite.reward4.title": "इनाम 4: सीमित समय के लाभ | नए उपयोगकर्ताओं के लिए विशेष उपहार",
    "invite.reward4.step1": "1幸运购买 में मुफ्त भागीदारी",
    "invite.reward4.step2": "1 मिस्ट्री बॉक्स लॉटरी को मुफ्त में सक्रिय करें",
    "invite.reward4.step3": "निर्दिष्ट कार्यों को पूरा करें और अतिरिक्त $1 नकद पुरस्कार प्राप्त करें",
    "reward.register.title": "पंजीकरण पुरस्कार",
    "reward.register.point1": "नए उपयोगकर्ताओं को पंजीकरण पर एक मुफ्त लकी खरीद प्रविष्टि मिलती है।",
    "reward.register.point2": "पंजीकरण के बाद समूह में शामिल होकर लाल लिफाफा कार्यक्रम में भाग लें।",
    "reward.task.title": "कार्य पुरस्कार",
    "reward.task.point1": "अतिथि के रूप में लॉग इन करें और एक ब्लाइंड बॉक्स खोलें।",
    "reward.task.point2": "निम्नलिखित तीन लकी बाय कार्यों को पूरा करें, प्रत्येक ज़ोन में एक बार:",
    "reward.task.subtask1": "$1 ज़ोन: $0.5 की एक खरीद",
    "reward.task.subtask2": "$3 ज़ोन: $1.5 की एक खरीद",
    "reward.task.subtask3": "$8 ज़ोन: $4 की एक खरीद",
    "reward.task.point3": "दोनों कार्य पूरे करें और $1 पुरस्कार प्राप्त करें!",
    "reward.share.title": "शेयरिंग पुरस्कार",
    "reward.share.desc": "मैंने अभी-अभी GoBuy पर एक सरप्राइज़ ब्लाइंड बॉक्स और एक लकी ड्रा जीता!",
    "reward.share.desc3": "रजिस्ट्रेशन के तुरंत बाद मैं जीत गया — बहुत शानदार!",
    "reward.share.desc4": "✨जीत की स्क्रीनशॉट शेयर करें और $1 का रिवॉर्ड पाएं।",
    "reward.share.desc1": "10 दोस्तों को आमंत्रित करें और उनके रजिस्ट्रेशन के बाद $1 कमाएँ। 1000 लोगों को आमंत्रित करके $100 पाएं — कोई सीमा नहीं, जितना ज़्यादा आमंत्रण, उतना ज़्यादा इनाम!",
    "reward.invite.title": "आमंत्रण पुरस्कार",
    "reward.invite.desc": "10 दोस्तों को सफलतापूर्वक आमंत्रित करें और पंजीकरण पूरा कराएं।",
    "reward.share.desc2": "ऊपर दिए गए कार्य पूरे करें और शेयर व निमंत्रण पुरस्कार प्राप्त करें!",
    "reward.invite.desc1": "ऊपर दिए गए कार्य पूरे करके निमंत्रण पुरस्कार प्राप्त करें!",
}
export default en
